export const SEARCH_FILTER_PARAMS_KEYS = {
  OTHER_FILTERS: 'other_filters',
  CONTEXTUAL_FILTERS: 'contextual_filters',
};

export const SEARCH_PAGE_PARAMS_KEYS = {
  PAGE: 'page',
  ROWS_PER_PAGE: 'rowsPerPage',
};

export const SORTING_PARAMS_KEYS = {
  SORTING: 'sorting',
};

export const LOCATION_PARAMS_KEYS = {
  PREV_PATH: 'prev_path',
  PREV_PARAMS: 'prev_params',
};

/*----------
Token written into `other_filters` when a filter is explicitly set to
"no constraint" (e.g. Data Type -> All Data).

The FiltersV2 contract is that the option matching `defaultValue` is omitted
from `other_filters` entirely, so an explicit non-default "unset" needs a value
of its own to distinguish it from the default. `getDecodedURL` strips this
token (and the matching key in `contextual_filters`) so it never reaches the
API params.

WARNING: this is the *string* 'null', not the JS null literal, and the strip
in getDecodedURL is a plain value comparison. No single-select option in
FILTERS_META may legitimately carry 'null' as its value, or it would be
silently dropped from the API params. Multi-select filters are unaffected —
their values decode to arrays, which never match.
----------*/
export const FILTER_UNSET_VALUE = 'null';
